// react-native-vector-icons/MaterialCommunityIcons stand-in for the spike.
// One profile screen uses it directly and react-native-paper uses it for its
// own glyphs. Renders an accessible placeholder box the size of the icon;
// Phase 8 loads the real icon font.

import React from 'react';
import { Text, View } from 'react-native-web';

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: unknown;
  accessibilityLabel?: string;
}

export default function Icon({ name, size = 24, color = '#1C2C4F', style, accessibilityLabel }: IconProps) {
  return (
    <View
      style={[{ width: size, height: size, alignItems: 'center', justifyContent: 'center' }, style as object]}
      accessibilityRole="image"
      accessibilityLabel={accessibilityLabel ?? name}
    >
      <Text style={{ color, fontSize: Math.round(size * 0.7), lineHeight: size }}>{'●'}</Text>
    </View>
  );
}

Icon.getImageSource = async () => null;
Icon.loadFont = async () => undefined;
Icon.hasIcon = () => true;
